import LogicBox from './LogicBox';
export default LogicBox;


// WEBPACK FOOTER //
// ./src/components/LogicBox/index.js